import { Navigate, generatePath } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { PlanI18nEditPresenter } from "./presenter";
import { usePlanI18nEditQuery } from "../../model/repository/existing/query/use-plan-edit-query";

type Props = {
	hotelID: string;
	planID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const PlanI18nEditContainer = ({ hotelID, planID, activeLangCode, navigator }: Props) => {
	const serverModel = usePlanI18nEditQuery({ hotelID, planID, lang: activeLangCode });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DEFAULT, { hotelID, planID })} />;
	}

	return <PlanI18nEditPresenter activeLangCode={activeLangCode} navigator={navigator} serverModel={serverModel} />;
};

PlanI18nEditContainer.displayName = "PlanI18nEditContainer";
